import comp from "./ForgotPhonePassword";
export default comp;
